import { queryOptions, useQuery } from '@tanstack/react-query';

import { blogApi } from '../api/blog-api';

import { blogKeys } from './blog-keys';

export function blogPostQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: blogKeys.postDetail(storeId, id),
    queryFn: () => blogApi.getPost(storeId, id),
  });
}

export function useBlogPost(storeId: string, id: string) {
  return useQuery(blogPostQueryOptions(storeId, id));
}
